import apiClient from '@/services/api/apiClient';

export interface NotificationItem {
  id: string;
  userId: string;
  type: 'info' | 'success' | 'warning' | 'error';
  sourceType: string;
  sourceId: string;
  title: string;
  description: string | null;
  href: string | null;
  isRead: boolean;
  createdAt: string;
  updatedAt: string;
}

export const getNotifications = async () => {
  const { data } = await apiClient.get('/api/notifications');
  return data as { data: NotificationItem[]; unreadCount: number };
};

export const markNotificationRead = async (id: string) => {
  const { data } = await apiClient.patch(`/api/notifications/${id}/read`);
  return data;
};

export const markAllNotificationsRead = async () => {
  const { data } = await apiClient.post('/api/notifications/read-all');
  return data;
};

export const dismissNotification = async (id: string) => {
  await apiClient.delete(`/api/notifications/${id}`);
};
